import { HttpErrorResponse } from "@angular/common/http";
import { Component, Inject, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ModalConfirmacaoComponent } from "src/app/@shared/components";
import { AuthService } from "src/app/services/auth/auth.service";

@Component({
  selector: "app-modal-expiracao-senha",
  templateUrl: "./modal-expiracao-senha.component.html",
  styleUrls: ["./modal-expiracao-senha.component.scss"],
})
export class ModalExpiracaoSenhaComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalExpiracaoSenhaModel,
    private authService: AuthService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private dialogExpiracao: MatDialogRef<ModalExpiracaoSenhaComponent>
  ) {
    this.email = data.email;
    this.usuario = data.username;
    this.nomeUsuario = data.nome;
    this.retorno = data.retorno;
  }

  public camposNovaSenha: boolean = false;
  public email: string = "";
  public usuario: string = "";
  public nomeUsuario: string = "";
  public retorno: any;
  public passwordIsValid = false;
  hide: boolean = true;
  password: string;
  confirmPassword: string;

  public formAtualizarSenha: FormGroup = new FormGroup({
    newPassword: new FormControl("", Validators.required),
    newConfirmPassword: new FormControl("", Validators.required),
  });

  get newPassword() {
    return this.formAtualizarSenha.get("newPassword").value;
  }
  get newConfirmPassword() {
    return this.formAtualizarSenha.get("newConfirmPassword").value;
  }

  ngOnInit() {}

  confirm() {
    this.dialogExpiracao.close(1);
  }

  passwordValid(event) {
    this.passwordIsValid = event;
  }

  confirmar() {
    if (this.newPassword !== this.newConfirmPassword) {
      return this.openSnackBar(
        "Senhas não conferem",
        "OK",
        3000,
        "danger-snackbar"
      );
    } else {
      const dialogRef = this.dialog.open(ModalConfirmacaoComponent, {
        width: "540px",
        data: {
          texto: `Você tem certeza que deseja alterar a senha?`,
        },
      });
      dialogRef.afterClosed().subscribe(async (response) => {
        if (response === 1) {
          this.atualizar();
        }
      });
    }
  }

  atualizar() {
    if (this.newPassword !== this.confirmPassword) {
      return this.openSnackBar(
        "Senhas não conferem",
        "OK",
        3000,
        "danger-snackbar"
      );
    } else {
      this.authService.setState(this.retorno);
      const obj = {
        nome: this.nomeUsuario,
        usuario: this.usuario,
        password: this.newPassword,
        email: this.email,
      };
      this.authService.atualizarDados(obj).subscribe(
        (response: any[]) => {
          if (response) {
            this.openSnackBar(
              "Senha atualizada com sucesso!",
              "OK",
              3000,
              "success-snackbar"
            );
            this.dialogExpiracao.close(2);
          } else {
            this.formAtualizarSenha.get("newPassword").setValue("");
            this.formAtualizarSenha.get("newConfirmPassword").setValue("");
            this.openSnackBar(
              "Senha já usada anteriormente, digite nova Senha!",
              "OK",
              3000,
              "danger-snackbar"
            );
          }
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.openSnackBar(err.error.error, "OK", 3000, "danger-snackbar");
        }
      );
    }
  }

  public showNovaSenha() {
    this.camposNovaSenha = true;
  }

  openSnackBar(
    message: string,
    action: string,
    duration: number,
    panelClass?: string
  ): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}

export interface ModalExpiracaoSenhaModel {
  /** Título do modal, caso queira que seja exibido. */
  titulo?: string;
  diasExpiracaoSenha: number;
  email: any;
  username: any;
  nome: any;
  retorno: any;
}
